import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { EntityActionOption } from '@wdx/clmi/clmi-swagger-gen';
import { ModalManagementService } from '@wdx/clmi/ui';
import { WdxButtonStyle } from '@wdx/shared/components/wdx-button';
import { MoleculeActionButtonService } from '../services/molecule-action-button.service';

@Component({
    selector: 'clmi-actions-modal',
    templateUrl: './actions-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ActionsModalComponent {
    public moleculeActionButtonService = inject(MoleculeActionButtonService);
    public modalManagementService = inject(ModalManagementService);

    selectedItem: EntityActionOption;

    readonly WDX_BUTTON_STYLE = WdxButtonStyle;

    optionSelected(): void {
        const info = this.moleculeActionButtonService.actions$.value;

        this.moleculeActionButtonService.dispatchActionWithUrl(
            info.operationsSetup,
            info.action,
            this.selectedItem.code,
        );
    }

    updateSelectedItem(entityActionOption: EntityActionOption): void {
        this.selectedItem = entityActionOption;
    }
}
